import cls from "classnames";
import { useCallback, useEffect, useState } from "react";
import { usePopper } from "react-popper";

const showEvents = ["mouseenter", "focus", "click"];
const hideEvents = ["mouseleave", "blur"];

export default function InfoButton({ description }) {
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "right",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
      {
        name: "preventOverflow",
        options: {
          altAxis: true,
        },
      },
      {
        name: "flip",
        options: {
          fallbackPlacements: ["left", "bottom", "top"],
        },
      },
    ],
  });

  const show = useCallback(() => {
    setIsVisible(true);
  }, []);

  const hide = useCallback(() => {
    setIsVisible(false);
  }, []);

  useEffect(() => {
    if (referenceElement) {
      showEvents.forEach((event) => {
        referenceElement.addEventListener(event, show);
      });
      hideEvents.forEach((event) => {
        referenceElement.addEventListener(event, hide);
      });
    }
    return () => {
      if (referenceElement) {
        showEvents.forEach((event) => {
          referenceElement.removeEventListener(event, show);
        });
        hideEvents.forEach((event) => {
          referenceElement.removeEventListener(event, hide);
        });
      }
    };
  }, [referenceElement]);

  return (
    <>
      <div ref={setReferenceElement} className="outline-none cursor-pointer">
        <img src="/assets/icons/info.svg" className="cursor-pointer" />
      </div>
      <div
        className={cls("z-20", isVisible ? "visible" : "invisible", "max-w-[284px]")}
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
      >
        <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
          <div className="bg-gray-50 p-2">
            <div className="rounded-md px-2 transition duration-150 ease-in-out">
              <span className="text-sm font-medium text-gray-900">
                {description}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
